import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=d5a3bdee&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=d5a3bdee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a3bdee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a3bdee')) {
      api.createRecord('d5a3bdee', component.options)
    } else {
      api.reload('d5a3bdee', component.options)
    }
    module.hot.accept("./QuestionList.vue?vue&type=template&id=d5a3bdee&scoped=true", function () {
      api.rerender('d5a3bdee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/View/QuestionList.vue"
export default component.exports